import { CellData, TabData } from '@ddt-web/data-service';

export class PieDataUtil {
	/**
	 * Get the default pie series for the provided tabData, batch and index.
	 *
	 * @param {TabData} data the configured data after the initial API data request has been resolved.
	 * @param {number} dataIndex the index of the portfolio to be processed (defaulted to 0)
	 * @param {number} dataBatch the table data batch (defaulted to 0)
	 */
	public static getDefaultPieSeriesForTabData(data: TabData, dataIndex: number = 0, dataBatch: number = 0, ignoreEmpty: boolean = false): Array<any> {
		const portfolios = data.displayConfig.transpose ? data.tableData[dataBatch].headersX : data.tableData[dataBatch].headersY;
		const categories = data.displayConfig.transpose ? data.tableData[dataBatch].headersY : data.tableData[dataBatch].headersX;
		const seriesDataArray = data.tableData[dataBatch].cells
			.map((row: Array<CellData>, index: number) => {
				return {
					category: categories[index].formattedValue,
					name: categories[index].formattedValue,
					formattedY: row[dataIndex].formattedValue,
					y: row[dataIndex].rawValue,
					tooltip: `<div class="text-12"><span class="text-bold">${categories[index].formattedValue}</span><span> ${row[dataIndex].formattedValue}</span></div>`
				};
			})
			.filter(series => series.y !== undefined);

		let seriesSum = 0;
		seriesDataArray.forEach(series => (seriesSum += Number(series.y)));
		if (seriesSum < 100 && !ignoreEmpty) {
			seriesDataArray.push({
				category: 'EMPTY',
				name: 'EMPTY',
				formattedY: String(100 - seriesSum),
				y: 100 - seriesSum,
				tooltip: `<div class="text-12"><span class="text-bold">EMPTY</span><span> ${100 - seriesSum}</span></div>`
			});
		}

		return [
			{
				name: portfolios[dataIndex].formattedValue,
				data: seriesDataArray
			}
		];
	}

	/**
	 * Get the default pie title for the provided tabData, batch and index.
	 *
	 * @param {TabData} data the configured data after the initial API data request has been resolved.
	 * @param {number} dataIndex the index of the Portfolio to be processed (defaulted to 0)
	 * @param {number} dataBatch the table data batch (defaulted to 0)
	 */
	public static getDefaultPieTitleForTabData(data: TabData, dataIndex: number = 0, dataBatch: number = 0): string {
		const headers = data.displayConfig.transpose ? data.tableData[dataBatch].headersX : data.tableData[dataBatch].headersY;
		return headers[dataIndex].formattedValue;
	}
}
